import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { getButtonVariantProps } from 'pricing-pages-ui-components/utils/buttonVariantUtils';
import { createProductConfig } from 'pricing-pages-lib/utils/productConfigUtils';
import { PROFESSIONAL } from 'self-service-api/constants/ProductLevels';
import { SALES } from 'self-service-api/constants/ProductLines';
import { TRIAL } from 'ui-addon-upgrades/_core/purchaseMotions/PurchaseMotionTypes';
import { SCREENS } from '../../constants/tracking/Screens';
import { APP, SSM0010_RECOMMENDED_SALES_FOOTER } from '../../constants/tracking/TrackingSources';
import { useGlobalLoading } from '../../hooks/loadingHooks';
import { useAppSelector } from '../../reducers';
import { hasPurchaseMotionsSucceededSelector } from '../../selectors/LoadingStateSelectors';
import { productSelector, upgradeProductSelector } from '../../selectors/ProductsSelectors';
import { purchaseMotionsSelector } from '../../selectors/PurchaseMotionSelectors';
import { useQueryParamTerm } from '../../utils/urls/appQueryParamUtils';
import { LoadableWrapper } from '../common/LoadableWrapper';
import SkeletonLoadWrapper from '../common/loading/SkeletonLoadWrapper';
import LoadingMerchCardCTAs from '../merch-card/LoadingMerchCardCTAs';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const RecommendedStarterFooter = () => {
  const isAppReady = useGlobalLoading();
  const hasPurchaseMotionsSucceeded = useAppSelector(hasPurchaseMotionsSucceededSelector);
  const ctaVariantProps = getButtonVariantProps({
    variant: 'block'
  });
  const {
    queryParamTerm
  } = useQueryParamTerm();
  const product = useAppSelector(state => {
    return productSelector(state, {
      productLine: SALES,
      productLevel: PROFESSIONAL
    });
  });
  const skuId = product === null || product === void 0 ? void 0 : product.currentSkuId;
  const purchaseMotions = useAppSelector(state => {
    if (!isAppReady) return [];
    const motions = purchaseMotionsSelector(state, {
      skuId: skuId || 0
    });
    return motions.includes(TRIAL) ? [TRIAL] : motions;
  });
  const upgradeProduct = useAppSelector(state => upgradeProductSelector(state, {
    skuIds: skuId ? [skuId] : []
  }));
  if (!product) return null;
  const productConfigurations = [createProductConfig({
    skuId: skuId || 0,
    quantity: 1
  })];
  const upgradeData = {
    app: APP,
    screen: SCREENS.RECOMMENDED,
    uniqueId: `${SSM0010_RECOMMENDED_SALES_FOOTER}-${upgradeProduct}`,
    upgradeProduct
  };
  if (!purchaseMotions.includes(TRIAL)) {
    return null;
  }
  return /*#__PURE__*/_jsx(View, {
    backgroundColor: "fill-brand-subtle",
    padding: "1400",
    inlineSize: "100%",
    children: /*#__PURE__*/_jsxs(View, {
      marginInline: "auto",
      maxInlineSize: "900px",
      children: [/*#__PURE__*/_jsx(Text, {
        as: "h3",
        textAlign: "center",
        marginBlockEnd: "500",
        typography: "body-400",
        children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "recommendedSalesFooter.title"
        })
      }), /*#__PURE__*/_jsx(View, {
        inlineSize: "300px",
        marginInline: "auto",
        children: /*#__PURE__*/_jsx(SkeletonLoadWrapper, {
          isLoading: !hasPurchaseMotionsSucceeded,
          heights: [40],
          widths: [200],
          children: /*#__PURE__*/_jsx(LoadableWrapper, {
            loader: () => import( /* webpackChunkName: "authed-chunk" */`pricing-pages-ui/components/auth-cta-motions/AuthedCTAs`),
            componentProps: Object.assign({
              queryParamTerm,
              upgradeData,
              purchaseMotions,
              productConfigurations,
              trackingSource: SSM0010_RECOMMENDED_SALES_FOOTER,
              returnFirstCTAOnly: true,
              primaryButtonUse: 'secondary',
              secondaryButtonUse: 'secondary',
              purchaseMotionLocation: 'MERCH_CARD'
            }, ctaVariantProps),
            LoadingComponent: LoadingMerchCardCTAs
          })
        })
      })]
    })
  });
};
export default RecommendedStarterFooter;